import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DataBreachApi extends BaseApi {
    constructor(client) {
        super(client, '/data-breach');
    }

    async getAuthorityForm(id) {
        try {
            const response = await this.client.get(
                `${this.basePath}/${id}/authority-form`,
                { responseType: 'text' },
            );
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
